import authHelper from '@/helpers/auth';
import apiAuth from '@/api/vo-general/autentikasi';

const defaultState = () => ({
	isAuth: authHelper.loggedIn(),
	isAttempting: false,
	responseError: {},
	userData: authHelper.getUserData(),
});

const state = defaultState();

const getters = {
	isAuth(state) {
		return state.isAuth;
	},
};

const mutations = {
	attempting(state) {
		state.isAttempting = true;
		state.responseError.show = false;
	},
	attempted(state) {
		state.isAttempting = false;
	},
	failed(state, data) {
		state.responseError = data
	},
	setProfileData(state, data) {
		authHelper.setProfileData(data);
		state.userData = authHelper.getUserData();
		state.isAuth = true;
		state.responseError.show = false;
	},
	setImageData(state, data) {
		authHelper.setImageData(data);
		state.userData = authHelper.getUserData();
		state.isAuth = true;
		state.responseError.show = false;
	},
	updateImage(state, image) {
		state.userData.member_image_url = image
		authHelper.setData(state.userData);
		state.userData = authHelper.getUserData();
	},
	success(state, authData) {
		state.responseError = {}
		authHelper.setData(authData);
		state.userData = authHelper.getUserData();
		state.isAuth = true;
		state.responseError.show = false;
	},
	successSSO(state, authData) {
		localStorage.removeItem('mlmcore-vo-auth-data')
		authHelper.clearData();
		authHelper.setData(authData);
		state.userData = authHelper.getUserData();
		state.isAuth = true;
		state.responseError.show = false;
	},
	removeAlert(state, id) {
		const index = Array.from(state.alerts).findIndex(it => it.id === id);

		if (index !== -1) {
			state.alerts.splice(index, 1);
		}
	},
	clearData(state) {
		state.isAuth = false;
		authHelper.clearData();
	},
	reset(state) {
		Object.assign(state, defaultState());
	},
};

const actions = {
	login({ commit, dispatch }, { username, password }) {
		return new Promise((resolve, reject) => {
			commit('attempting');
			apiAuth.login(username, password).then((res) => {
				let data = res.data.data.results
				data['token'] = res.data.data.token
				commit('success', data);
				dispatch('success', res.data, { root : true });
				resolve(data);
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			}).then(() => {
				commit('attempted');
			});
		});
	},
	loginsso({ commit }, data) {
		return new Promise((resolve) => {
			commit('successSSO', data);
			resolve()
		});
	},
	verifyToken({ commit, dispatch }, { token }) {
		return new Promise((resolve, reject) => {
			commit('attempting');
			apiAuth.verifyToken(token).then(() => {
				resolve(true);
				commit('attempted');
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
				reject(data)
			})
		});
	},

	// reset password
	kirimOTP({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiAuth.kirimOTP(params).then(() => {
				resolve(true);
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data, { root : false });
				reject(data)
			})
		});
	},
	verifyOTP({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiAuth.verifyOTP(params).then(() => {
				resolve(true);
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data, { root : false });
				reject(data)
			})
		});
	},
	resetPassword({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiAuth.resetPassword(params).then(() => {
				resolve(true);
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
				reject(data)
			})
		});
	},
	// end reset password

	logout({ commit }) {
		commit('clearData');

		return Promise.resolve(true);
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.data.error) {
				case 'validation':
					commit('setErrorValidation', response.data.data)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;

			}
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};